import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/throw';
import { catchError } from 'rxjs/operators';
import { ContentResponse } from '../model';


export class RequestServiceBase {

    private data: Observable<any>;

    constructor (protected http: HttpClient) { }

    // post() - Request base for POST request
    post(url: string, body, jsonHeaders: number = 0): Observable<any> {
      return this.http.post<ContentResponse>(url, body, {
        headers: this.getHeaders(jsonHeaders)
      }).pipe(
        catchError(err => { return Observable.throw(err); })
      );
    }

    // put - Request base for PUT request
    put(url: string, body): Observable<any> {
      return this.http.put(url, body)
        .pipe(
          catchError(err => { return Observable.throw(err); })
        );
    }

    // get - Request base for GET request
    get(url: string): Observable<any> {
      this.data =  this.http.get(url)
        .pipe(
          catchError(err => { return Observable.throw(err); })
        );
      return this.data;
    }

    // get - Request base for GET request
    getImage(url: string): Observable<any> {
      this.data =  this.http.get(url, {
        responseType: 'arraybuffer'
      })
        .pipe(
          catchError(err => { return Observable.throw(err); })
        );
      return this.data;
    }

    // delete - Request base for DELETE request
    delete(url: string, body): Observable<any> {
      return this.http.delete(url, body)
        .pipe(
          catchError(err => { return Observable.throw(err); })
        );
    }

    // getHeaders() - Get headers for the HTTP request
    getHeaders(type: number = 0): any {
      let _headers = new HttpHeaders();
      const HeaderType = {
        APPLICATION_JSON: 'application/json',
        MULTIPART_DATA: 'multipart/form-data',
        IMAGE_DATA: 'image/jpeg'
      };

      switch (type) {
      case 0:
        _headers = _headers.set('Content-Type', HeaderType.APPLICATION_JSON);
        break;
      case 1:
        _headers.append('Content-Type', HeaderType.MULTIPART_DATA);
        break;
      case 2:
        _headers.set('Accept', HeaderType.IMAGE_DATA);
        break;
      default:
        _headers = _headers.set('Content-Type', HeaderType.APPLICATION_JSON);
        break;
      }

      return _headers;
    }
}
